import React, { Component } from "react";
import { Form, Input, Button, Alert } from "antd";
import { ReactComponent as Logo } from "../../svgs/logo.svg";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router";
import { withTranslation } from "react-i18next";
import "./style.scss";

/**
 * Component for showing recovery password page.
 *
 * @component
 */
@inject("rootStore")
@observer
class OtpVerification extends Component {
  /**
   * handleReSentClick
   * resent the OTP code
   *
   */
  handleReSentClick = () => {
    const {
      rootStore: {
        authStore: { resendOTP },
      },
    } = this.props;
    resendOTP();
  };

  /**
   * componentDidMount
   * check whenever logined user enter the forgot page -redirect to home page
   * clear all error list
   */
  componentDidMount = () => {
    const {
      t,
      rootStore: {
        authStore: { clearErrorList },
      },
    } = this.props;
    document.title = t("otp.page-title");
    clearErrorList();
  };
  /**
   * trimString
   * @param {String} text
   * @returns {String} value with trim
   */
  trimString = (value) => {
    return value?.trim();
  };
  /**
   * handleSubmit
   * validation input then send back to store
   *
   */
  handleSubmit = (e) => {
    e.preventDefault();
    const {
      rootStore: {
        authStore: { verifyOTP },
      },
    } = this.props;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        verifyOTP(values);
      }
    });
  };
  /**
   * render
   *
   * @return  {Component}
   */
  render() {
    const { getFieldDecorator } = this.props.form;
    const {
      rootStore: {
        authStore: { loading, errorList, clearErrorList },
      },
      t,
    } = this.props;
    return (
      <div className="wrap-passwordreset-comp">
        <div className="wrap-login-error-comp">
          {errorList && (
            <Alert
              message={errorList.message}
              type="error"
              closable
              showIcon
              onClose={clearErrorList}
              className="spm-error-comp"
            />
          )}
        </div>
        <div className="wrap-login-comp">
          <Form onSubmit={this.handleSubmit} className="passwordreset-form">
            <div className="logo-login">
              <Logo className="logo-img"> </Logo>
            </div>
            <div className="title-login">{t("otp.otp_title")}</div>

            <div className="description-login">{t("otp.otp_description")}</div>
            <Form.Item required={false} label={t("otp.otp")}>
              {getFieldDecorator("token_code", {
                normalize: this.trimString,
                rules: [{ required: true, message: t("otp.otp_required") }],
              })(
                <Input maxLength={10} placeholder={t("otp.otp_placholder")} />
              )}
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="reset-form-button"
                loading={loading}
              >
                {t("otp.verify")}
              </Button>
              <a
                className="login-form login-form-forgot"
                onClick={this.handleReSentClick}
              >
                {t("otp.re-sent")}
              </a>
            </Form.Item>
          </Form>
        </div>
      </div>
    );
  }
}

const OtpVerificationForm = Form.create({ name: "otp_ResetPassword" })(
  OtpVerification
);

export default withRouter(withTranslation()(OtpVerificationForm));
